import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import OrcComplementarProvider from "./context/OrcComplementar";
import WebServiceProvider from "./context/WebServiceContext";

ReactDOM.render(
  <React.StrictMode>
    <WebServiceProvider>
      <OrcComplementarProvider>
        <App />
      </OrcComplementarProvider>
    </WebServiceProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
